<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="list_keyno" [ttModel]="edit.list_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="list_name" [(ttModel)]="edit.list_name" ttRequired></tt-input>
        <tt-button-goto [ttText]="'list_listdatas'" [ttBadge]="edit.nbr_of_listdata" [ttGoto]="'listdatas'" [ttGotoParms]="{ list_keyno: edit.list_keyno }"></tt-button-goto>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
